<button *ngIf="isVisible" mat-icon-button class="ml-2 clear-button" (click)="onClear()">
  <mat-icon>close</mat-icon>
</button>
